

/**
 * @class
 * Firmware model
 */
export default class Firmware {

    /**
     * @constructor
     * @param {String} name Firmware name
     * @param {Array} file Firmware file
     * @param {String} url Firmware url
     * @param {String} type Firmware type
     */
    constructor(
      name,
      file,
      url,
      type
    ){ 
      this._name = name
      this._file = file
      this._url = url
      this.type = type
    }

    get name(){
      return this._name
    }
    set name(name){
      this._name = name
    }

    get file(){
        return this._file
    }
    set file(file){
        this._file = file
    }

    get url(){
      return this._url
    }
    set url(url){
        this._url = url
    }

    get type(){
      return this._type
    }
    set type(type){
        this._type = type
    }
  }